// @mui
import { ButtonBase, MenuItem, MenuList, Popover, Typography } from '@mui/material';
import { menuItemClasses } from '@mui/material/MenuItem';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { useCallback, useState } from 'react';

// utils

// ----------------------------------------------------------------------

const RenderPopOverButton = ({ handleOpenPopover, openPopover, handleClosePopover, customTriggerComponent, setSelectedItem, items, iconName, backgroundColor, bordered = false, customTitle, width, height, minWidth, customContent }) => {
    const navigate = useNavigate()
    const [menu, setMenu] = useState(null);
    const openPopoverHandle = useCallback((event) => {
        event.stopPropagation();
        setMenu(event.currentTarget);
        setSelectedItem && setSelectedItem();
    }, []);
    const [hovered, setHovered] = useState(null);

    const closePopover = useCallback((event) => {
        event.stopPropagation();
        setMenu(null);
    }, []);

    const runAndClose = useCallback((fn) => (e) => {
        e.stopPropagation();
        if (handleClosePopover) handleClosePopover(e);
        setMenu(null);
        requestAnimationFrame(() => fn && fn());
    }, [handleClosePopover]);


    return (
        <>
            {
                <>
                    {
                        customTriggerComponent ? customTriggerComponent :
                            <ButtonBase
                                style={{
                                    paddingBlock: customTitle ? 0 : 3,
                                    paddingInline: customTitle ? 0 : 7,
                                    borderRadius: 10,
                                    marginLeft: customTitle ? 0 : 5,
                                    backgroundColor: backgroundColor || 'white',
                                    color: '#101010',
                                    width: width ? width : 'auto',
                                    fontWeight: 500,
                                    height: height ? height : 'auto',
                                    alignContent: 'center',
                                    border: bordered ? "1px solid #EAE8E7" : '0px',
                                }}
                                onClick={handleOpenPopover || openPopoverHandle}
                            >
                                {customTitle ? customTitle : <Icon icon={iconName ? iconName : "ri-more-2-line"} height={18} width={18} />}
                            </ButtonBase>
                    }
                    <Popover
                        sx={{
                            "& .MuiPaper-root": {
                                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.08)",
                                borderRadius: "10px"
                            },
                        }}
                        open={!!openPopover || !!menu}
                        anchorEl={openPopover || menu}
                        onClose={handleClosePopover || closePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        {
                            customContent ? customContent :
                                <MenuList
                                    disablePadding
                                    sx={{
                                        p: 0.5,
                                        gap: 1,
                                        border: "1px solid #EAE8E7",
                                        minWidth: minWidth || 180,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        [`& .${menuItemClasses.root}`]: {
                                            px: 1,
                                            gap: 2,
                                            borderRadius: 2,
                                            '&:hover': {
                                                backgroundColor: hovered === 'Delete' ? '#F651510D' : '#F8F8F8',
                                                color: 'white',
                                            },
                                            [`&.${menuItemClasses.selected}`]: { bgcolor: 'action.selected' },
                                        },
                                    }}
                                >
                                    {
                                        items?.length > 0 && items.map((el, idx) => {
                                            return (
                                                el.permission !== false &&
                                                <MenuItem
                                                    onMouseEnter={() => setHovered(el.label)}
                                                    onMouseLeave={() => setHovered(null)}
                                                    // onClick={(e) => {e.stopPropagation(); el.onClick()}} 
                                                    onClick={runAndClose(el.onClick)}
                                                    style={{ color: el?.color || '#000000', padding: "8px", paddingLeft: "10px" }}
                                                    key={idx}>
                                                    <Icon icon={el.iconName} fontSize={16} />
                                                    <span style={{ fontFamily: 'SophiaPro', fontSize: 14 }}>{el.label}</span>
                                                    {el?.subLabel &&
                                                        <span className='subheader-2' style={{ display: 'flex', justifyContent: 'end', width: '50%' }}>
                                                            {el.subLabel}
                                                        </span>
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </MenuList>
                        }

                    </Popover>
                </>

            }
        </>

    );
}
export default (RenderPopOverButton);
